"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.convert = void 0;

var aqiCodes = __importStar(require("./aqi"));
/**
 * For any pollutant, convert an AQI to its raw concentration, or vice versa,
 * or convert an AQI to another AQI
 *
 * @param pollutant - The pollutant to convert
 * @param from - The type to convert from (either raw, or an AQI)
 * @param to - The type to convert to (either raw, or an AQI)
 * @param value - The value to convert
 */


function convert(pollutant, from, to, value) {
  if (from === 'raw' && to === 'raw') {
    return value;
  } // Convert raw to AQI


  if (from === 'raw') {
    return aqiCodes[to].fromRaw(pollutant, value);
  } // Convert AQI to raw


  if (to === 'raw') {
    return aqiCodes[from].toRaw(pollutant, value);
  } // Convert AQI to AQI


  var raw = aqiCodes[from].toRaw(pollutant, value);
  return aqiCodes[to].fromRaw(pollutant, raw);
}

exports.convert = convert;